import React, { Fragment, useEffect, useState } from 'react';
import GSCService from '../Services/GSCService';
import { AccordionComponent } from './Accordion';
import Chip from './Chip';
import { NotificationManager } from 'react-notifications';

export default function GSCKwsReport({ domain, page, body = "" }) {

    const [lost, setLost] = useState(null);
    const [added, setAdded] = useState(null);
    const [currentKws, setCurrentKws] = useState(null);
    const onClick = (text) => {
        navigator.clipboard.writeText(text);
        NotificationManager.info(`Copied`);
    };
    useEffect(() => {

        GSCService.getNewKeywordsOfPage({ domain, page }).then(c => {
            const { lostKws, addedKws, currentKeywords } = c;
            setLost(lostKws);
            setAdded(addedKws);
            setCurrentKws(currentKeywords);
        }).catch(e => {
            console.error(e);
        })
    }, []);

    return <Fragment>

        <AccordionComponent items={[{
            head: 'Lost KWs',
            body: <Fragment>
                <p>Keywords where we used to appear, but not any more</p>
                {lost && <div className="flex flex-wrap justify-center space-x-2">
                    <Chip onClick={() => { onClick(lost.map(kw => kw.keyword).reduce((prev, current) => `${prev} \n ${current}`), '') }} label={"Copy All"} color={"bg-green-200 cursor-pointer"} />
                    <Chip onClick={() => { onClick(lost.map(kw => kw.keyword).reduce((prev, current) => `${prev} \n "${current}"`), '') }} label={"Copy All With Quotes"} color={"bg-green-200 cursor-pointer"} />
                </div>
                }
                <div className="flex flex-wrap justify-center space-x-2">
                    {lost && lost
                        .sort((a, b) => b.impressions - a.impressions)
                        .map(kw => <Chip onClick={() => { onClick(kw.keyword) }} label={`${kw.keyword} - ${Math.floor(kw.position)} - ${kw.impressions} - ${Math.round(kw.ctr * 100) / 100}`} color={body.toLowerCase().indexOf(kw.keyword.toLowerCase()) >= 0 ? "bg-green-200 cursor-pointer" : "bg-red-100 cursor-pointer"} />)}
                </div>
            </Fragment>
        }, {
            head: 'New KWs(in order of importance)',
            body:
                <Fragment>
                    <p>Keywords where we appeared for first time in the last few days</p>
                    {added && <div className="flex flex-wrap justify-center space-x-2">
                        <Chip onClick={() => { onClick(added.map(kw => kw.keyword).reduce((prev, current) => `${prev} \n ${current}`), '') }} label={"Copy All"} color={"bg-green-200 cursor-pointer"} />
                        <Chip onClick={() => { onClick(added.map(kw => kw.keyword).reduce((prev, current) => `${prev} \n "${current}"`), '') }} label={"Copy All With Quotes"} color={"bg-green-200 cursor-pointer"} />
                    </div>
                    }
                    <div className="flex flex-wrap justify-center space-x-2">
                        {added && added
                            .sort((a, b) => b.impressions - a.impressions)
                            .map(kw => <Chip onClick={() => { onClick(kw.keyword) }} label={`${kw.keyword} - ${Math.floor(kw.position)} - ${kw.impressions} - ${Math.round(kw.ctr * 100) / 100}`} color={body.toLowerCase().indexOf(kw.keyword.toLowerCase()) >= 0 ? "bg-green-200 cursor-pointer" : "bg-red-100 cursor-pointer"} />)}
                    </div>
                </Fragment>
        },
        {
            head: "Accidental Rankers(in order of importance)",
            body: <Fragment>
                <p>Keywords where we appear between position 4-20 and it is not on the body of the article</p>
                {currentKws && <div className="flex flex-wrap justify-center space-x-2">
                    <Chip onClick={() => {
                        onClick(currentKws.filter(kw => kw.position > 3 && kw.position < 21 && body.toLowerCase().indexOf(kw.keyword.toLowerCase()) < 0)
                            .sort((a, b) => a.position - b.position).map(kw => kw.keyword).reduce((prev, current) => `${prev} \n ${current}`), '')
                    }} label={"Copy All"} color={"bg-green-200 cursor-pointer"} />
                    <Chip onClick={() => {
                        onClick(currentKws.filter(kw => kw.position > 3 && kw.position < 21 && body.toLowerCase().indexOf(kw.keyword.toLowerCase()) < 0)
                            .sort((a, b) => a.position - b.position).map(kw => kw.keyword).reduce((prev, current) => `${prev} \n "${current}"`), '')
                    }} label={"Copy All With Quotes"} color={"bg-green-200 cursor-pointer"} />
                </div>
                }
                <div className="flex flex-wrap justify-center space-x-2">
                    {currentKws && currentKws.filter(kw => kw.position > 3 && kw.position < 21 && body.toLowerCase().indexOf(kw.keyword.toLowerCase()) < 0)
                        .sort((a, b) => a.position - b.position)
                        .map(kw => <Chip onClick={() => { onClick(kw.keyword) }} label={`${kw.keyword} - ${Math.floor(kw.position)} - ${kw.impressions} - ${Math.round(kw.ctr * 100) / 100}`} color={body.toLowerCase().indexOf(kw.keyword.toLowerCase()) >= 0 ? "bg-green-200 cursor-pointer" : "bg-red-100 cursor-pointer"} />)}

                </div></Fragment>
        }]} />
    </Fragment>
}